var Dashboard = function () { return import('@/pages/dashboard/Index.vue'); };
var AuthenticationCallback = function () { return import('@/pages/authentication/Index.vue'); };
var Legacy = function () { return import('@/pages/legacy/Index.vue'); };
var NotFound = function () { return import('@/pages/app/NotFound.vue'); };
var Forbidden = function () { return import('@/pages/app/Forbidden.vue'); };
var HealthCheck = function () { return import('@/pages/health-check/Index.vue'); };
import { legacyRoutes } from './legacy';
import { legacyConfigRoutes } from './legacy-config';
import { spaRoutes } from './spa';
import { spaConfigRoutes } from './spa-config';
var baseRoutes = [
    {
        name: 'Dashboard',
        path: '/',
        component: Dashboard,
    },
    {
        name: 'Health Check',
        path: '/hc',
        component: HealthCheck,
    },
    {
        name: 'Authenticated Callback',
        path: '/authenticated',
        component: AuthenticationCallback,
    },
    {
        name: 'Legacy',
        path: '/legacy/:page',
        component: Legacy,
    },
    {
        name: 'Forbidden',
        path: '/forbidden',
        component: Forbidden,
    },
    {
        name: 'Not Found',
        path: '*',
        component: NotFound,
    },
];
export var routes = baseRoutes
    .concat(legacyRoutes)
    .concat(legacyConfigRoutes)
    .concat(spaRoutes)
    .concat(spaConfigRoutes);
